export default __webpack_public_path__ + "b8551c6571a96a2f6d67b134b8fe070c.svg";